/* eslint-disable react-hooks/exhaustive-deps */
import { node } from 'prop-types'
import React from 'react'
import flagsmith from 'flagsmith'
import { FlagsmithProvider, useFlagsmith } from 'flagsmith/react'
import { useAuthProvider } from 'shared/application/hooks/useAuthProvider.hook'

const FlagsmithIdentity = ({ children }) => {
  const { user } = useAuthProvider()
  const flagsmithInstance = useFlagsmith()
  const flagsmithIdentity = flagsmithInstance.identity

  if (!flagsmithIdentity && user?.id) {
    flagsmithInstance.identify(user?.id)
  }

  return (
    <>{children}</>
  )
}

const FeatureFlagsProvider = ({ children }) => {
  return (
    <FlagsmithProvider options={{ environmentID: process.env.PUBLIC_FLAGSMITH_KEY }} flagsmith={flagsmith}>
      <FlagsmithIdentity>
          {children}
      </FlagsmithIdentity>
    </FlagsmithProvider>
  )
}

FeatureFlagsProvider.propTypes = {
  children: node.isRequired,
}

export { FeatureFlagsProvider }
